module.exports = __webpack_public_path__ + "static/media/declined.689a3029.svg";